import React, { createContext, useContext, useState, useEffect } from "react";
import { serverTime } from "../../../Utils/Socket";

const TimerContext = createContext(null);

export const TimerProvider = ({ children }) => {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      // Trigger re-render for all subscribers by incrementing tick
      setTick((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <TimerContext.Provider value={{ tick, getServerTime: () => serverTime }}>
      {children}
    </TimerContext.Provider>
  );
};

export const useTimerTick = () => {
  const context = useContext(TimerContext);
  if (!context) {
    // Fallback for components not wrapped in provider
    return { tick: 0, getServerTime: () => serverTime };
  }
  return context;
};

export default TimerContext;
